export function foundationClasses(classes, props) {
  if (props.classes || props.className) {
    return (classes += " " + props.classes + " " + props.className);
  } else {
    return classes;
  }
}
